import React, { Component } from 'react';
import _ from 'lodash';
import Joi from 'joi-browser';
import moment from 'moment';

import {
  FormElement,
  FormListItem,
  FormListSubHeader,
} from './CommonFormComponents';
import { RadioButtonIcon } from './icons/RadioButtonIcon';
import CompanyConstructionIndustryForm from './forms/CompanyConstructionIndustryForm';
import { ConstructionPermitTable } from './tables/ConstructionPermitTable';
import { CreateFromLicenseCcusErrorDialog } from './modals/CreateFromLicenseCcusErrorDialog';
import {
  ATTACH_DOCUMENT_TYPE_COMPANY,
  DATE_TIME_FORMAT,
  EXISTANCE_FLAG,
  PERMISSION_GROUP_TYPE,
  PREFECTURE_LISTS,
  PREFECTURE_GROUPS,
} from '../utilities/constants';
import {
  isConstructionIndustryPermissionStatus,
  showPrefectureInput,
  showRegionalDevelopmentBureau,
} from '../utilities/companySafetyUtil';
import { ErrorIcon } from './icons/ErrorIcon';
import { Description } from './Description';
import { Confirmation } from './modals/common';
import { validationRegexByJoi } from '../utilities/commonValidation';
import {
  attachDocumentCompanyUploadState,
  attachDocumentDeleteState,
} from '../utilities/attachDocumentUtil';
import companyBranchPermissionCommonSchema from '../utilities/validationSchemas/companyBranchPermissionCommonSchema';
import {
  convertDate,
  DEFAULT_YEAR_PLUS,
  DEFAULT_YEAR_START,
  hasOnlyNumber,
  isValidDate,
  stringToDate,
} from '../utilities/validateDateUtil';
import { localizeMessage } from '../utilities/validateMessage';
import LicenseInformationTable from './tables/LicenseInformationTable';
import { INDUSTRY } from '../utilities/roanConstants';
import { messageUtility } from '../utilities/messageUtility';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import { CompanyService } from '../services/Companies';
import dialogLoader from '../utilities/dialogLoader';
import {
  isDuplicateConstructionIndustry,
  isDuplicateWithCurrentLicenses,
  getDataWithoutInvalidFlag,
  isDuplicateLicenseInfo,
} from '../utilities/CompanySaftyLicenseUtil.js';
import { FeedbackIcon } from './icons/FeedbackIcon';

const COMPANY_BRANCH_PERMISSION = {
  permitted_source_section: '',
  prefectures_code_id: '',
  regional_development_bureau_id: null,
  construction_industry_permission_section: '',
  company_branch_permissions: [],
  permission_number_l: '',
  permission_number_r: '',
  license_update_date: '',
  license_limit_date: '',
  permission_group_type: PERMISSION_GROUP_TYPE.common,
  company_documents: [],
};

const LABEL_BUTTON_CANCEL = {
  edit: '編集をやめる',
  create: '追加をやめる',
};

const TITLE_DIALOG = {
  create: '建設業許可情報追加',
  edit: '建設業許可情報編集',
};

class CompanyLicenseInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowForm: false,
      formValues: _.cloneDeep(COMPANY_BRANCH_PERMISSION),
      validate: {
        messages: {},
        invalid: false,
      },
      isDuplicateRecord: false,
      isDuplicateNumberR: false,
      isInvalidOldData: false,
      titleDialog: TITLE_DIALOG.create,
      labelButton: LABEL_BUTTON_CANCEL.create,
      isCcusCreateForm: false,
      warningMsg: {
        license_update_date: '',
        otherIndustry: '',
      },
      isShowConfirmDialog: false,
      selectedCcusId: null,
      duplicateLicenseIds: [],
    };
    this.formEvents = {
      handleOnChange: this.handleOnChange,
      handleValidate: this.handleValidate,
      handleOnChangePermissionFlag: this.handleOnChangePermissionFlag,
      handleOnChangeDate: this.handleOnChangeDate,
      handleOnChangeAuthorizedIndustry: this.handleOnChangeAuthorizedIndustry,
      handleValidateIndustry: this.handleValidateIndustry,
      handleOnChangeOtherAuthorizedIndustry: this
        .handleOnChangeOtherAuthorizedIndustry,
    };
    this.attachmentEvents = {
      uploadFile: this.uploadFile,
      deleteFile: this.deleteFile,
    };
    this.schema = Joi.object().keys(companyBranchPermissionCommonSchema);
    this.isCheckingValidDataFlag = false;
    this.isDuplicateNumberR = false;
    this.isChangeDate = false;
    this.isSubmitting = false;
  }

  componentDidMount() {
    this.setInvalidData();
  }

  componentDidUpdate(preProps, prestate) {
    if (
      prestate.isDuplicateNumberR !== this.state.isDuplicateNumberR &&
      this.state.isDuplicateNumberR
    ) {
      const el = document.querySelector(
        '.CompanyLicenseInformationDialog .dialog-md__body'
      );
      if (el) {
        el.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }
    if (
      this.props.values.company_branch_permissions !==
      preProps.values.company_branch_permissions
    ) {
      if (this.isCheckingValidDataFlag) {
        return;
      }
      this.isCheckingValidDataFlag = true;
      this.setInvalidData(true);
    }
  }

  handleToggleForm = status => {
    this.setState({
      isShowForm: status,
    });
  };

  handleToggleConfirmDialog = isShow => {
    this.setState({
      isShowConfirmDialog: isShow,
    });
  };

  handleCloseForm = () => {
    this.setState(
      {
        formValues: COMPANY_BRANCH_PERMISSION,
        validate: {
          invalid: false,
          messages: {},
        },
        isDuplicateRecord: false,
        isDuplicateNumberR: false,
        isCcusCreateForm: false,
      },
      () => this.handleToggleForm(false)
    );
  };

  /**
   * Update permission flag
   * @param {object} event: event input
   */
  updatePermissionFlag = event => {
    if (Number(event.target.value) === EXISTANCE_FLAG.NOEXIST.VALUE) {
      this.setState({
        isShowForm: false,
      });
    }
    this.props.events.setFormValue('company_detail', event);
  };

  /**
   * Handle change permission flag
   * @param {object} event: event input
   */
  handleOnChangePermissionFlag = event => {
    const {
      values: { company_branch_permissions: permissionGroups },
      events: { handleDeletePermissionExistGreenFile },
    } = this.props;
    if (
      Number(event.target.value) === EXISTANCE_FLAG.NOEXIST.VALUE &&
      _.isFunction(handleDeletePermissionExistGreenFile)
    ) {
      event.persist();
      const idsToDelete = _.filter(permissionGroups, group => !group.isCreate)
        .flatMap(({ company_branch_permissions }) => company_branch_permissions)
        .filter(
          ({ id, _destroy }) => id && _destroy !== EXISTANCE_FLAG.EXIST.ID
        )
        .map(({ id }) => id);
      handleDeletePermissionExistGreenFile(idsToDelete, () =>
        this.updatePermissionFlag(event)
      );
    } else {
      this.updatePermissionFlag(event);
    }
  };

  handleOnChange = (e, name, callback = null) => {
    const { value } = e.target;
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  };

  handleOnChangeDate = (value, name, callback = null) => {
    this.isChangeDate = true;
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          [name]: value,
        },
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  };

  updateAuthorizedIndustryStatus = (checked, industry) => {
    let constructorIndustries = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    const authorized_industry_codes = _.get(
      industry,
      'construct_permit_industry_type_code'
    );
    const authorized_industry_names = _.get(
      industry,
      'construct_permit_industry_type_name'
    );
    const authorized_industry_short_name =
      _.get(industry, 'construct_permit_industry_type_short_name') || null;
    const index = _.findIndex(
      constructorIndustries,
      item =>
        Number(item.authorized_industry_codes) ===
        Number(authorized_industry_codes)
    );
    if (index !== -1) {
      if (!constructorIndustries[index]['id']) {
        constructorIndustries.splice(index, 1);
      } else {
        constructorIndustries[index]['_destroy'] = checked
          ? null
          : EXISTANCE_FLAG.EXIST.ID;
      }
    } else {
      constructorIndustries.push({
        authorized_industry_codes,
        authorized_industry_names,
        authorized_industry_short_name,
        id: null,
      });
    }
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          company_branch_permissions: constructorIndustries,
        },
      },
      () => this.handleValidate(null, 'company_branch_permissions')
    );
  };

  handleOnChangeAuthorizedIndustry = (event, industry) => {
    const checked = event.target.checked;
    const {
      events: { handleDeletePermissionExistGreenFile },
    } = this.props;
    const constructorIndustries = _.get(
      this.state,
      'formValues.company_branch_permissions'
    );
    const authorized_industry_codes = _.get(
      industry,
      'construct_permit_industry_type_code'
    );
    const { id } =
      _.find(
        constructorIndustries,
        item =>
          Number(item.authorized_industry_codes) ===
          Number(authorized_industry_codes)
      ) || {};
    if (_.isFunction(handleDeletePermissionExistGreenFile) && !checked && id) {
      handleDeletePermissionExistGreenFile([id], () => {
        this.updateAuthorizedIndustryStatus(checked, industry);
      });
    } else {
      this.updateAuthorizedIndustryStatus(checked, industry);
    }
  };

  updateOtherAuthorizedIndustry = id => {
    const constructorIndustries = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    const index = _.findIndex(
      constructorIndustries,
      item => Number(item.id) === Number(id)
    );
    if (index !== -1) {
      constructorIndustries[index]['_destroy'] = EXISTANCE_FLAG.EXIST.ID;
      this.setState(
        {
          formValues: {
            ...this.state.formValues,
            company_branch_permissions: constructorIndustries,
          },
        },
        () => {
          const warning = this.handleValidateCompanyBranchPermissionOther();
          this.handleValidate(null, 'company_branch_permissions');
          this.setState({
            warningMsg: {
              ...this.state.warningMsg,
              otherIndustry: warning,
            },
            formValues: {
              ...this.state.formValues,
              other_authorized_industry_invalid_flag: !!warning,
            },
          });
        }
      );
    }
  };

  handleOnChangeOtherAuthorizedIndustry = id => {
    const {
      events: { handleDeletePermissionExistGreenFile },
    } = this.props;
    if (_.isFunction(handleDeletePermissionExistGreenFile)) {
      handleDeletePermissionExistGreenFile([id], () =>
        this.updateOtherAuthorizedIndustry(id)
      );
    } else {
      this.updateOtherAuthorizedIndustry(id);
    }
  };

  handleParamValidate = params => {
    const data = {};
    data.permitted_source_section =
      Number(params.permitted_source_section) || undefined;
    data.prefectures_code_id = params.prefectures_code_id || undefined;
    data.construction_industry_permission_section =
      Number(params.construction_industry_permission_section) || undefined;
    data.regional_development_bureau_id =
      params.regional_development_bureau_id || undefined;
    data.license_update_date = params.license_update_date || undefined;
    data.permission_number_l = params.permission_number_l || '';
    data.permission_number_r = params.permission_number_r || '';
    return data;
  };

  handleValidateIndustry = () => {
    const { company_branch_permissions, license_update_date } = _.cloneDeep(
      this.state.formValues
    );
    const { validate } = this.props;
    const result = _.filter(
      company_branch_permissions,
      item => !_.get(item, '_destroy')
    );
    let message = '';
    if (_.isEmpty(result)) {
      return localizeMessage.required;
    }
    if (!license_update_date || _.get(validate, 'license_update_date')) {
      return '';
    }
    _.forEach(this.props.values.company_branch_permissions, item => {
      if (isDuplicateConstructionIndustry(item, this.state.formValues)) {
        message = '同一の許可業種で既に登録されている許可があります。';
        return false;
      }
    });
    return message;
  };

  handleValidate = (e, name) => {
    const values = this.handleParamValidate(_.cloneDeep(this.state.formValues));
    const companyBranchPermissions = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    const validate = _.cloneDeep(this.state.validate);
    const result = validationRegexByJoi(this.schema, values, false);
    if (name) {
      if (result.messages[name]) {
        validate.messages[name] = result.messages[name];
      } else if (validate.messages[name]) {
        validate.messages = _.omit(validate.messages, [name]);
      }
    }
    if (name === 'license_update_date') {
      const msgLicenseUpdateDate = this.handleValidateLicenseUpdateDate(
        _.get(values, 'license_update_date')
      );
      if (msgLicenseUpdateDate) {
        validate.messages['license_update_date'] = msgLicenseUpdateDate;
      }
      const industries = _.filter(
        this.state.formValues.company_branch_permissions,
        item =>
          !_.get(item, '_destroy') && _.get(item, 'authorized_industry_codes')
      );
      if (!_.isEmpty(industries)) {
        const msgCompanyBranchPermission = this.handleValidateIndustry();
        if (isNullOrUndefinedOrEmptyStr(msgCompanyBranchPermission)) {
          validate.messages = _.omit(
            validate.messages,
            'company_branch_permissions'
          );
        } else {
          validate.messages[
            'company_branch_permissions'
          ] = msgCompanyBranchPermission;
        }
      }
    }
    if (name === 'company_branch_permissions') {
      const msgCompanyBranchPermission = this.handleValidateIndustry();
      if (msgCompanyBranchPermission) {
        validate.messages[
          'company_branch_permissions'
        ] = msgCompanyBranchPermission;
      }
    }
    if (name === 'company_branch_permissions_other') {
      const msg = this.handleValidateCompanyBranchPermissionOther();
      if (msg) {
        validate.messages['company_branch_permissions_other'] = msg;
      }
    }
    if (
      name === 'prefectures_code_id' &&
      Number(_.get(values, 'prefectures_code_id')) !==
        PREFECTURE_GROUPS.hokkaido_tohoku.prefectures.hokkaido.id &&
      validate.messages['regional_development_bureau_id']
    ) {
      validate.messages = _.omit(
        validate.messages,
        'regional_development_bureau_id'
      );
    }
    if (
      Number(_.get(values, 'permitted_source_section')) ===
      INDUSTRY.permissions.source[1].id
    ) {
      validate.invalid = !_.isEmpty(
        _.omit(validate.messages, [
          'prefectures_code_id',
          'regional_development_bureau_id',
        ])
      );
    } else {
      validate.invalid = !_.isEmpty(validate.messages);
    }
    if (this.filesCheck()) {
      validate.invalid = true;
    }
    let isDuplicateNumberR = false;
    if (
      !_.has(validate.messages, 'permission_number_r') &&
      !_.has(validate.messages, 'license_update_date')
    ) {
      if (!this.checkHasOtherIndustry(companyBranchPermissions)) {
        isDuplicateNumberR = isDuplicateWithCurrentLicenses(
          this.state.formValues,
          this.props.values.company_branch_permissions
        );
      }
      if (isDuplicateNumberR) {
        validate.invalid = true;
      }
    }
    this.setState({
      validate,
      isDuplicateNumberR,
    });
    return validate.invalid;
  };

  handleValidateLicenseUpdateDate = value => {
    this.setState({
      warningMsg: {
        ...this.state.warningMsg,
        license_update_date: '',
      },
    });
    if (this.isChangeDate) {
      this.setState({
        formValues: {
          ...this.state.formValues,
          license_limit_date: '',
        },
      });
    }

    const [year, month, day] = stringToDate(value);
    if (!year && !month && !day) {
      return localizeMessage.required;
    }

    if (
      (year && !hasOnlyNumber(year)) ||
      (month && !hasOnlyNumber(month)) ||
      (day && !hasOnlyNumber(day))
    ) {
      return messageUtility.getMessage('E-000-017');
    }
    const yearEnd = moment()
      .add(DEFAULT_YEAR_PLUS, 'years')
      .get('year');
    const yearStart = DEFAULT_YEAR_START;
    if ((year && Number(year) < yearStart) || Number(year) > yearEnd) {
      return `${yearStart}年〜${yearEnd}年の間で入力してください。`;
    }

    const currentDate = moment();
    const sizeOfCurrentYear = _.size(String(currentDate.year()));
    const sizeOfYear = _.size(year);
    if (
      !year ||
      !isValidDate(Number(year), Number(month), Number(day)) ||
      sizeOfYear > sizeOfCurrentYear
    ) {
      return '年月日を正しく入力してください。';
    }

    const startDate = moment()
      .startOf('date')
      .subtract(5, 'years');
    const valueDate = moment(value, DATE_TIME_FORMAT.slashDateFormat);
    let licenseLimitDate = _.cloneDeep(
      this.state.formValues.license_limit_date
    );
    if (this.isChangeDate) {
      const licenseUpdateDate = convertDate(value);
      licenseLimitDate = moment(licenseUpdateDate).add(5, 'years');
      if (!(Number(day) === 29 && Number(month) === 2)) {
        licenseLimitDate.subtract(1, 'days');
      }
      this.setState({
        formValues: {
          ...this.state.formValues,
          license_limit_date: licenseLimitDate.format(
            DATE_TIME_FORMAT.slashDateFormat
          ),
        },
      });
    }
    if (
      sizeOfYear < sizeOfCurrentYear ||
      valueDate.isSameOrBefore(startDate) ||
      moment().isAfter(licenseLimitDate, 'date')
    ) {
      this.setState({
        warningMsg: {
          ...this.state.warningMsg,
          license_update_date: messageUtility.getMessage('E-001-419'),
        },
      });
    }
  };

  handleValidateCompanyBranchPermissionOther = () => {
    const otherIndustries = _.filter(
      this.state.formValues.company_branch_permissions,
      data => !data.authorized_industry_codes
    );
    const otherIndustriesChecked = _.filter(otherIndustries, data =>
      _.get(data, '_destroy')
    );
    if (_.size(otherIndustries) > _.size(otherIndustriesChecked)) {
      return '許可業種の指定が誤っています。29業種から選択してください。';
    }
  };

  uploadFile = async (file, typeL, typeS) => {
    attachDocumentCompanyUploadState(
      this.state.formValues.company_documents,
      documents => {
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              company_documents: documents,
            },
          },
          this.handleValidate
        );
      },
      this.props.selectedCompanyId,
      file,
      typeL,
      typeS
    );
  };

  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.formValues.company_documents,
      documents => {
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              company_documents: documents,
            },
          },
          this.handleValidate
        );
      },
      file
    );
  };

  handleSubmitForm = async isCreate => {
    const { eventCompanyBranchPermissionCommon } = this.props;
    const formValue = _.cloneDeep(this.state.formValues);
    if (isCreate) {
      formValue.isCreate = true;
      formValue.id = _.uniqueId('company_branch_permission_id');
    }
    formValue.invalid_flag = false;
    if (
      formValue.permitted_source_section != INDUSTRY.permissions.source[2].id ||
      formValue.prefectures_code_id !=
        PREFECTURE_GROUPS.hokkaido_tohoku.prefectures.hokkaido.id
    ) {
      formValue.regional_development_bureau_id = null;
    }
    await eventCompanyBranchPermissionCommon.handleCompanyBranchPermission(
      formValue,
      isCreate,
      () => !isCreate && this.removeDuplicateStatusByEditSuccess(formValue)
    );
    this.setInvalidData();
    this.handleCloseForm();
    this.handleToggleConfirmDialog(false);
  };

  removeDuplicateStatusByEditSuccess = data => {
    const { ccusCompanyBranchPermissions } = this.props;
    const { selectedCcusId, duplicateLicenseIds } = this.state;
    let ccusLicense = _.find(ccusCompanyBranchPermissions, [
      'id',
      selectedCcusId,
    ]);

    if (!_.includes(duplicateLicenseIds, data.id)) {
      return;
    }

    if (
      isDuplicateLicenseInfo(data, ccusLicense, true) ||
      isDuplicateConstructionIndustry(data, ccusLicense)
    ) {
      return;
    }
    this.removeDuplicateLicenseId(data.id);
  };

  removeDuplicateLicenseId = id => {
    const { selectedCcusId, duplicateLicenseIds } = this.state;
    if (_.isEmpty(selectedCcusId) || _.isEmpty(duplicateLicenseIds)) {
      return;
    }
    const newDuplicateLicenseIds = _.filter(
      duplicateLicenseIds,
      item => item !== id
    );
    this.setState({
      selectedCcusId: _.isEmpty(newDuplicateLicenseIds) ? null : selectedCcusId,
      duplicateLicenseIds: newDuplicateLicenseIds,
    });
  };

  handleCheckDuplicateConstructionPermission = async () => {
    const invalid = this.handleValidateAll();
    if (invalid || this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    const { formValues } = this.state;
    let licenseKeys = ['permitted_source_section', 'permission_number_r'];
    if (showPrefectureInput(formValues.permitted_source_section)) {
      licenseKeys.push('prefectures_code_id');
      if (showRegionalDevelopmentBureau(formValues.prefectures_code_id)) {
        licenseKeys.push('regional_development_bureau_id');
      }
    }
    const param = _.pick(formValues, licenseKeys);
    const response = await CompanyService.checkDuplicateConstructionPermission(
      this.props.selectedCompanyId,
      param
    );
    this.isSubmitting = false;
    const duplicate_flag = _.get(response, 'data.entities.duplicate_flag');
    if (duplicate_flag) {
      return this.handleToggleConfirmDialog(true);
    }
    this.handleSubmitForm(!_.get(formValues, 'id'));
  };

  handleValidateAll = () => {
    const values = this.handleParamValidate(_.cloneDeep(this.state.formValues));
    const companyBranchPermissions = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    const result = validationRegexByJoi(this.schema, values, true);
    let messages = {};
    const msgLicenseUpdateDate = this.handleValidateLicenseUpdateDate(
      _.get(values, 'license_update_date')
    );
    const msgCompanyBranchPermission = this.handleValidateIndustry();
    const warningMsgOtherIndustry = this.handleValidateCompanyBranchPermissionOther();
    if (msgLicenseUpdateDate) {
      messages['license_update_date'] = msgLicenseUpdateDate;
    }
    if (msgCompanyBranchPermission) {
      messages['company_branch_permissions'] = msgCompanyBranchPermission;
    }
    if (!result.status) {
      messages = {
        ...messages,
        ...result.messages,
      };
    }
    if (
      Number(values.permitted_source_section) ===
      INDUSTRY.permissions.source[1].id
    ) {
      messages = _.omit(messages, [
        'prefectures_code_id',
        'regional_development_bureau_id',
      ]);
    }
    let invalid = !_.isEmpty(messages);
    let isDuplicateNumberR = false;
    if (!this.checkHasOtherIndustry(companyBranchPermissions)) {
      isDuplicateNumberR = isDuplicateWithCurrentLicenses(
        this.state.formValues,
        this.props.values.company_branch_permissions
      );
    }

    if (isDuplicateNumberR) {
      invalid = true;
    }
    if (this.filesCheck()) {
      invalid = true;
    }
    this.setState({
      validate: {
        invalid,
        messages: {
          ...messages,
        },
      },
      warningMsg: {
        ...this.state.warningMsg,
        otherIndustry: warningMsgOtherIndustry,
      },
      isDuplicateNumberR,
    });
    return invalid;
  };

  handleDeleteRow = async (id, isCreate) => {
    const { eventCompanyBranchPermissionCommon } = this.props;
    await eventCompanyBranchPermissionCommon.handleDeleteCompanyBranchPermission(
      id,
      isCreate,
      () => this.removeDuplicateLicenseId(id)
    );
    this.setInvalidData();
  };

  handleShowFormCreate = () => {
    this.setState({
      titleDialog: TITLE_DIALOG.create,
      labelButton: LABEL_BUTTON_CANCEL.create,
      isShowForm: true,
      warningMsg: {
        ...this.state.warningMsg,
        license_update_date: '',
      },
    });
  };

  handleShowFormEdit = data => {
    this.isChangeDate = false;
    if (!_.has(data, 'company_documents')) {
      data.company_documents = [];
    }
    if (!_.has(data, 'company_branch_permissions')) {
      data.company_branch_permissions = [];
    }
    this.setState(
      {
        formValues: data,
        titleDialog: TITLE_DIALOG.edit,
        labelButton: LABEL_BUTTON_CANCEL.edit,
      },
      () => {
        this.handleValidateAll();
        this.handleToggleForm(true);
      }
    );
  };

  editLicense = id => {
    const { values } = this.props;
    const record = _.find(
      _.get(values, 'company_branch_permissions'),
      value => value.id === id
    );
    this.handleShowFormEdit(record);
  };

  checkDuplicateRecord = () => {
    const companyBranchPermissionGroups = _.cloneDeep(
      this.props.values.company_branch_permissions
    );
    const formValues = _.cloneDeep(this.state.formValues);
    if (_.isEmpty(companyBranchPermissionGroups)) {
      return false;
    }
    const formValue = this.handleFiledCheckDuplicateRecord(formValues);
    let isDuplicateRecord = false;
    _.forEach(companyBranchPermissionGroups, companyBranchPermissionGroup => {
      const industries = _.filter(
        companyBranchPermissionGroup.company_branch_permissions,
        item => !!item.authorized_industry_codes && !_.get(item, '_destroy')
      );
      if (companyBranchPermissionGroup.id === formValues.id) {
        return;
      }
      isDuplicateRecord = this.checkDuplicateAuthorizedIndustry(
        formValues,
        industries
      );
      if (!isDuplicateRecord) {
        return;
      }
      const data = this.handleFiledCheckDuplicateRecord(
        companyBranchPermissionGroup
      );
      if (_.isEqual(formValue, data)) {
        return false;
      }
      isDuplicateRecord = false;
    });
    this.setState({
      isDuplicateRecord,
    });
    return isDuplicateRecord;
  };

  checkDuplicateAuthorizedIndustry = (data, oldData) => {
    let isDuplicate = true;
    const oldDataObj = _.keyBy(oldData, 'authorized_industry_codes');
    const companyBranchPermissions = _.filter(
      data.company_branch_permissions,
      item =>
        _.get(item, 'authorized_industry_codes') && !_.get(item, '_destroy')
    );
    if (_.size(companyBranchPermissions) !== _.size(oldDataObj)) {
      return false;
    }
    _.forEach(companyBranchPermissions, item => {
      if (!oldDataObj[item.authorized_industry_codes]) {
        isDuplicate = false;
        return false;
      }
    });
    return isDuplicate;
  };

  handleFiledCheckDuplicateRecord = data => {
    return _.pick(data, [
      'permitted_source_section',
      'prefectures_code_id',
      'regional_development_bureau_id',
      'construction_industry_permission_section',
      'permission_number_l',
      'permission_number_r',
    ]);
  };

  setInvalidData = (isUpdated = false) => {
    let isInvalidOldData = false;
    const companyBranchPermission = _.get(
      this.props.values,
      'company_branch_permissions'
    );
    if (
      Number(
        _.get(
          this.props.values.company_detail,
          'construction_industry_permission_flag'
        )
      ) === INDUSTRY.permissions.construction[1].id
    ) {
      _.forEach(companyBranchPermission, data => {
        if (data.invalid_flag || data.other_authorized_industry_invalid_flag) {
          isInvalidOldData = true;
          return false;
        }
      });
    }
    this.setState({ isInvalidOldData }, () => {
      if (isUpdated) {
        this.isCheckingValidDataFlag = false;
      }
    });
  };

  checkHasOtherIndustry(companyBranchPermissions) {
    const result = _.filter(companyBranchPermissions, data => {
      return !data.authorized_industry_codes && !data._destroy;
    });
    return !_.isEmpty(result);
  }

  getFormValuesFromCcusLicense = license => {
    return {
      ..._.pick(license, [
        'permitted_source_section',
        'prefectures_code_id',
        'regional_development_bureau_id',
        'construction_industry_permission_section',
        'permission_number_l',
        'permission_number_r',
        'license_update_date',
        'license_limit_date',
        'permission_group_type',
      ]),
      company_branch_permissions: license.company_branch_permissions.map(
        permission => _.omit(permission, ['id'])
      ),
      company_documents: [],
    };
  };

  getDuplicateLicenseWithCcus = (ccusLicense, buildLicense) => {
    const validGroups = getDataWithoutInvalidFlag(buildLicense);
    return _.filter(
      validGroups,
      group =>
        isDuplicateLicenseInfo(group, ccusLicense, true) ||
        isDuplicateConstructionIndustry(group, ccusLicense)
    );
  };

  handleCreateFromCcusLicense = ccusLicense => {
    const {
      values,
      bureaux,
      documentCodes,
      eventCompanyBranchPermissionCommon,
    } = this.props;

    const duplicateLicenses = _.cloneDeep(
      this.getDuplicateLicenseWithCcus(
        ccusLicense,
        values.company_branch_permissions
      )
    ).map(license => {
      license.invalid_flag = true;
      return license;
    });

    if (_.isEmpty(duplicateLicenses)) {
      this.setState(
        {
          formValues: this.getFormValuesFromCcusLicense(ccusLicense),
          selectedCcusId: null,
          duplicateLicenseIds: [],
          isCcusCreateForm: true,
        },
        () => {
          this.handleShowFormCreate();
          this.handleValidateAll();
        }
      );
    } else {
      dialogLoader.show(CreateFromLicenseCcusErrorDialog, {
        ccusLicense,
        duplicateLicenses,
        bureaux,
        documentCodes,
        callback: {
          onClose: () => {
            dialogLoader.close();
            this.setState({
              selectedCcusId: ccusLicense.id,
              duplicateLicenseIds: _.map(duplicateLicenses, 'id'),
            });
          },
          onDownload: eventCompanyBranchPermissionCommon.download,
        },
      });
    }
  };

  renderConstructionIndustryPermission = () => {
    const { readOnly, values } = this.props;
    return (
      <FormListItem label='建設業許可有無' required={!readOnly}>
        <FormElement>
          <div className='form-list-radio'>
            {_.map(EXISTANCE_FLAG, item => {
              const formValue = Number(
                _.get(
                  values,
                  'company_detail.construction_industry_permission_flag'
                )
              );
              const itemValue = Number(item.VALUE);
              return readOnly ? (
                formValue === itemValue && (
                  <span key={item.VALUE}>{item.TEXT}</span>
                )
              ) : (
                <div className='form-list-radio__item' key={item.VALUE}>
                  <label className='radio'>
                    <input
                      type='radio'
                      id={`form-radio-construction_industry_permission_flag-${
                        item.ID
                      }`}
                      value={item.VALUE}
                      name='construction_industry_permission_flag'
                      checked={formValue === itemValue}
                      onChange={e => this.handleOnChangePermissionFlag(e)}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{item.TEXT}</span>
                  </label>
                </div>
              );
            })}
          </div>
        </FormElement>
      </FormListItem>
    );
  };

  renderButtonCreate = () => {
    const { readOnly, ccusCompanyBranchPermissions } = this.props;
    const { isShowForm } = this.state;
    return (
      this.isHasConstructionIndustryPermission() &&
      !readOnly && (
        <FormListItem isBorder={_.isEmpty(ccusCompanyBranchPermissions)}>
          <button
            className={isShowForm ? 'btn--disabled' : 'btn--sub'}
            onClick={() =>
              !this.state.isShowForm && this.handleShowFormCreate()
            }
          >
            許可情報を追加
          </button>
        </FormListItem>
      )
    );
  };

  isHasConstructionIndustryPermission = () => {
    return isConstructionIndustryPermissionStatus(
      _.get(
        this.props.values,
        'company_detail.construction_industry_permission_flag'
      )
    );
  };

  renderTableList = () => {
    const {
      values,
      readOnly,
      bureaux,
      eventCompanyBranchPermissionCommon,
      documentCodes,
    } = this.props;
    const { isInvalidOldData, duplicateLicenseIds } = this.state;

    if (this.isHasConstructionIndustryPermission()) {
      return (
        <React.Fragment>
          {!readOnly && (
            <FormListItem label='許可情報' required={true} isBorder={false} />
          )}
          <FormListItem
            className='form-list__item form-list__item-table'
            isBorder={false}
          >
            {this.renderCcusNotice()}
            <LicenseInformationTable
              data={values.company_branch_permissions}
              readOnly={readOnly}
              isInvalidOldData={isInvalidOldData}
              download={eventCompanyBranchPermissionCommon.download}
              documentCodes={_.filter(documentCodes, document => {
                return (
                  document.file_typeL ===
                  ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION
                );
              })}
              bureaux={bureaux}
              duplicateLicenseIds={duplicateLicenseIds}
              onEdit={this.editLicense}
              onDelete={this.handleDeleteRow}
            />
          </FormListItem>
        </React.Fragment>
      );
    }
  };
  renderDescription = () => {
    return (
      this.state.isInvalidOldData &&
      isConstructionIndustryPermissionStatus(
        _.get(
          this.props.values,
          'company_detail.construction_industry_permission_flag'
        )
      ) && (
        <FormListItem className='form-list__item form-list__item-description'>
          <Description type='primary'>
            <ErrorIcon className='icon--1_4x form-list__error-icon' />
            が表示されている許可情報は登録内容に誤りがあります。
            正しい情報に変更してください。
          </Description>
        </FormListItem>
      )
    );
  };
  filesCheck = () => {
    const {
      formValues: { company_documents },
    } = this.state;
    return (
      _.some(company_documents, 'invalidSize') || 
      _.some(company_documents, 'invalidType') || 
      _.some(company_documents, 'invalidName')
    );
  };

  renderMessageConfirmDialog = () => {
    const { formValues } = this.state;
    const { bureaux } = this.props;
    let prefectureName = '大臣';
    let bureauxName = '';
    if (showPrefectureInput(formValues.permitted_source_section)) {
      prefectureName = PREFECTURE_LISTS[formValues.prefectures_code_id];
      if (showRegionalDevelopmentBureau(formValues.prefectures_code_id)) {
        bureauxName = _.get(
          _.find(
            bureaux,
            bureauxItem =>
              String(bureauxItem.id) ===
              String(formValues.regional_development_bureau_id)
          ),
          'bureau_name'
        );
      }
    }
    return (
      <div>
        <div className='ConfirmDuplicateConstructionPermitDialog-warning'>
          <span className='ConfirmDuplicateConstructionPermitDialog-warning__text'>
            許可元区分：{prefectureName}　{bureauxName}
          </span>
          <br />
          <span className='ConfirmDuplicateConstructionPermitDialog-warning__text'>
            許可番号 固有番号：{formValues.permission_number_r}
          </span>
        </div>
        <div className='ConfirmDuplicateConstructionPermitDialog__message'>
          {messageUtility.getMessage('I-000-170')}
        </div>
      </div>
    );
  };
  renderCcusTable = () => {
    const { readOnly, bureaux, ccusCompanyBranchPermissions } = this.props;
    if (
      this.isHasConstructionIndustryPermission() &&
      !readOnly &&
      !_.isEmpty(ccusCompanyBranchPermissions)
    ) {
      return (
        <React.Fragment>
          <FormListItem className='form-list__item form-list__item-table'>
            <div className='ccus-title'>CCUS入力情報</div>
          </FormListItem>
          <FormListItem className='form-list__item form-list__item-table'>
            <ConstructionPermitTable
              data={ccusCompanyBranchPermissions}
              readOnly={readOnly}
              isCcusMode={true}
              bureaux={bureaux}
              selectedCcusId={this.state.selectedCcusId}
              onCreate={this.handleCreateFromCcusLicense}
              isInvalidOldData={this.state.isInvalidOldData}
            />
          </FormListItem>
        </React.Fragment>
      );
    }
  };

  renderCcusNotice = () => {
    if (this.props.readOnly || !this.state.selectedCcusId) {
      return null;
    }
    return (
      <div className='ccus-description'>
        <FeedbackIcon className='ccus-description__icon ccus-description__icon--yellow' />
        <span className='ccus-description__text'>
          が表示された許可情報を削除または修正すると
        </span>
        <FeedbackIcon className='ccus-description__icon ccus-description__icon--blue' />
        <span className='ccus-description__text'>
          が表示された許可情報の転記が行えるようになります。
        </span>
      </div>
    );
  };

  render() {
    const {
      checkboxList,
      bureaux,
      industryDefault,
      companyDocuments,
      documentCodes,
      selectedCompanyId,
      events,
    } = this.props;
    const {
      isShowForm,
      validate,
      formValues,
      isDuplicateRecord,
      titleDialog,
      labelButton,
      isDuplicateNumberR,
      isShowConfirmDialog,
      isCcusCreateForm,
      warningMsg,
    } = this.state;
    return (
      <div className='CompanyLicenseInformation' id='CompanyLicenseInformation'>
        <FormListSubHeader title='建設業許可情報' />
        {this.renderDescription()}
        {this.renderConstructionIndustryPermission()}
        {this.renderTableList()}
        {this.renderButtonCreate()}
        {this.renderCcusTable()}
        <Confirmation
          title={titleDialog}
          visible={isShowForm}
          rootClassName='CompanyLicenseInformationDialog'
          cancelButtonText={labelButton}
          confirmButtonText='決定'
          message={
            <CompanyConstructionIndustryForm
              checkboxList={checkboxList}
              bureaux={bureaux}
              industryDefault={industryDefault}
              companyDocuments={companyDocuments}
              documentCodes={documentCodes}
              validate={validate}
              formValues={formValues}
              isDuplicateRecord={isDuplicateRecord}
              isDuplicateNumberR={isDuplicateNumberR}
              formEvents={this.formEvents}
              attachmentEvents={this.attachmentEvents}
              selectedCompanyId={selectedCompanyId}
              hiddenForm={() => this.handleToggleForm(false)}
              events={events}
              warningMsg={warningMsg}
              isCcusCreateForm={isCcusCreateForm}
            />
          }
          effectiveButtonClassName={
            validate.invalid ? 'btn--disabled' : 'btn--effective'
          }
          onCancel={this.handleCloseForm}
          onConfirm={this.handleCheckDuplicateConstructionPermission}
        />
        <Confirmation
          title='建設許可番号が重複しています'
          rootClassName='dialog--wide ConfirmDuplicateConstructionPermitDialog'
          visible={isShowConfirmDialog}
          onCancel={() => this.handleToggleConfirmDialog(false)}
          onConfirm={() => this.handleSubmitForm(!_.get(formValues, 'id'))}
          cancelButtonText='編集画面に戻る'
          confirmButtonText='このまま更新'
          message={this.renderMessageConfirmDialog()}
          multilineText={true}
        />
      </div>
    );
  }
}

export default CompanyLicenseInformation;



// WEBPACK FOOTER //
// ./src/components/CompanyLicenseInformation.jsx